import { DiabetesStatusType, PregnancyStatusType } from '../../../types/quiz';
import { ReferralType } from '../../NhsSignup/state/state';
import { GenderType } from '@components/NhsSignup/Gender';

export type MseStateType = {
  nhsReferral: ReferralType | null;
  firstName: string;
  lastName: string;
  gender: GenderType | '';
  healthConditions: string[];
  pregnancyStatus: PregnancyStatusType[];
  eatingDisorderDiagnosis: string;
  openToMedication: string;
  diabetesStatus: DiabetesStatusType | undefined;
  diabetesManagement: string[];
  type2DiabetesMedication: string[];
  diabetesMedicationPrescriber: string;
  hasDiabetesDoctorsAppt?: boolean;
  diabetesComplications: string[];
  hasOtherHealthConditions?: boolean;
  healthConditionsOpenText: string;
  takesMedication?: boolean;
  currentMedication: string;
  hasAllergies: boolean | undefined;
  allergies: string;
  birthday: Date | undefined;
  disabilityStatus: string | undefined;
  disabilityType: string[];
  email: string;
  phoneNumber: string;
  password: string;
  addressFirstLine: string;
  addressCity: string;
  addressPostCode: string;
  ethnicity: string;
};

export const initialState: MseStateType = {
  nhsReferral: {
    _id: '',
    contract: '',
    signupCode: '',
    email: '',
    firstName: '',
    lastName: '',
    mobilePhoneNumber: '',
    baselineWeightInKg: 0,
    heightInM: 0,
  },
  firstName: '',
  lastName: '',
  gender: '',
  healthConditions: [],
  pregnancyStatus: [],
  eatingDisorderDiagnosis: '',
  openToMedication: '',
  diabetesStatus: undefined,
  diabetesManagement: [],
  type2DiabetesMedication: [],
  diabetesMedicationPrescriber: '',
  hasDiabetesDoctorsAppt: undefined,
  diabetesComplications: [],
  hasOtherHealthConditions: undefined,
  healthConditionsOpenText: '',
  takesMedication: undefined,
  currentMedication: '',
  hasAllergies: undefined,
  allergies: '',
  birthday: undefined,
  disabilityStatus: undefined,
  disabilityType: [],
  email: '',
  phoneNumber: '',
  password: '',
  addressFirstLine: '',
  addressCity: '',
  addressPostCode: '',
  ethnicity: '',
};
